export default "__VITE_ASSET__4O75Lmp8__"